import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../services/ApiService";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import PasswordComponent from "../components/verification/PasswordComponent";
import IconContentCard from "../components/shared/IconContentCard";
import { MdMarkEmailRead } from "react-icons/md";
import { FaServer, FaUnlink } from "react-icons/fa";

/**
 * MailVerifyPage 
 * 
 * after basic registration(HomePage modal fill) will be send email
 * with token, to verify customers email address
 * 
 * @url "/qr/mail/confimation/:token"
 * 
 * @components "components/verification/"
 * 
 * @returns {object} - saves known data to LocalStorage as json object
 */
const MailVerifyPage = () => {
    
    const API = new Api(); // Api Service
    const navigate = useNavigate(); // navigation
    const {token} = useParams(); // Client token which he got through mail
    const [tokenValid, setTokenValid] = useState(false) // Check for token if valid
    const [customer, setCustomer] = useState(); // Customer object
    const [loading, setLoading] = useState(true); // when data is loading
    const [apiError, setApiError] = useState("");


    // On render verifies email address, if exists show new password fields
    useEffect(() => {
        API.mail_verify(token)
            .then((res) => {
                setLoading(false);
                let data = res.data;
                setCustomer(data);
                setTokenValid(true);
            })
            .catch((err) => {
                setLoading(false);
                setTokenValid(false);
                if (err.code === "ERR_NETWORK") {
                    return setApiError("Kein Verbindung zum Server.")
                }
                if (err.response.status === 404) {
                    return setApiError("Die aufgerufene Adresse existiert nicht oder ist bereits ungültig.")
                }
                if (err.response.data.detail !== undefined) {
                    return setApiError(err.response.data.detail);
                } 
                setApiError("Unbekannter Fehler.");
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // Views
    return (
        <Container>
            <Row className="mt-5 mb-5">
                <h3><span className="text-energo">ENERGO</span> - E-Mail verifizieren</h3>
            </Row>

            {loading?
                <IconContentCard icon={<FaServer size={80} />}>
                    <Row>
                        <h5 className="text-energo">Daten werden überprüft...</h5>
                    </Row>
                    <Row>
                        <Col xs="12" className="mt-3">
                            <Spinner animation="grow" className="text-energo" style={{marginRight: 10}}/>
                            <Spinner animation="grow" className="text-energo" style={{marginRight: 10}}/>
                            <Spinner animation="grow" className="text-energo" style={{marginRight: 10}}/>
                        </Col>
                    </Row>
                </IconContentCard> :
            
            tokenValid  ? 
                <IconContentCard icon={<MdMarkEmailRead size={80} />}>
                    <Row>
                        <h5 className="text-energo">Ihre E-Mail Adresse wurde bestätigt</h5>
                    </Row>
                    <Row>
                        <Col xs="12" className="mt-5">
                            <p className="text-muted">
                                Geben Sie ein neues Passwort 
                                ein und klicken Sie auf <span className="text-energo">"Weiter"</span>
                            </p>
                            <PasswordComponent customer={customer} setCustomer={setCustomer} />
                        </Col>
                    </Row>
                </IconContentCard>
            :
                <IconContentCard icon={<FaUnlink size={80} />} variant="error">
                    <Row>
                        <h5 className="text-danger">Ihre E-Mail-Adresse konnte nicht verifiziert werden</h5>
                    </Row>
                    <Row className="mt-5">
                        <Col xs="12">
                            <p className="danger">{apiError}</p>
                        </Col>
                    </Row>
                    <Row className="mt-5 text-end">
                        <Col>
                            <Button onClick={() => navigate('/')} variant="danger">Zurück</Button>
                        </Col>
                    </Row>
                </IconContentCard>
            }
        </Container>
    )
}

export default MailVerifyPage;